import { useQuery } from '@tanstack/react-query';

import type { LeaveQuery } from '@lemoment/shared';

import { getLeaves, getMe, getTeamLeaves } from '../apis';
import { leaveKeys } from './leaveKeys';

export const useLeaves = (
  query: LeaveQuery = {},
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: leaveKeys.list(query),
    queryFn: () => getLeaves(query),
    select: (data) => data.leaves,
    enabled: options?.enabled,
  });

/** Whole-team active leaves for a month range — for the team calendar. */
export const useTeamLeaves = (query: { from: string; to: string }) =>
  useQuery({
    queryKey: leaveKeys.teamList(query),
    queryFn: () => getTeamLeaves(query),
    select: (data) => data.leaves,
  });

export const useMe = () =>
  useQuery({
    queryKey: leaveKeys.me(),
    queryFn: getMe,
  });
